export enum ButtonActionsLabel {
  OK = 'Ok',
  CANCEL = 'Annuler',
  CONTINUE = 'Continuer',
  CONFIRM = 'Confirmer',
  YES = 'Oui',
  NO = 'Non',
}

export enum ButtonActions {
  OK = 'ok',
  CANCEL = 'cancel',
  CONTINUE = 'continue',
  CONFIRM = 'confirm',
  YES = 'yes',
  NO = 'no',
}
